import React from "react";
import Layout from "../components/Layout";

function Testimonials() {
  const reviews = [
    {
      name: "Cory S.",
      date: "August 19, 2024",
      text: "Vehicle was in very good condition and well-maintained. Location was very close to my residence with no additional charge and on time. Host was very professional and would highly recommend this vehicle for anybody looking to rent for the holidays or whatever the occasion may be. I will definitely rent from this host again.",
    },
    {
      name: "Taylor Brody",
      date: "January 20, 2025",
      text: "We rented an amazing Raptor truck from Joey at Kelowna Auto Rentals. The truck was ready for us at the airport super clean and full of gas. Left it at the airport, super fast and easy. I can’t wait to rent the next time I’m in town. Best cars, great service.",
    },
    {
      name: "Cory Smith",
      date: "January 3, 2025",
      text: "I had the pleasure of renting a couple of vehicles from Joey And the company Kelowna auto rentals. Great personality very professional vehicles are always dropped off on time and are always clean and in excellent condition always full tank of gas, couldn’t ask for a better company to rent from!…would highly recommend to anybody That is looking to rent.",
    },
    {
      name: "Dylan N.",
      date: "December 13, 2024",
      text: "Seamless process from start to finish, very responsive and accommodating. The car was flawless as well, very comfortable and efficient ride. I’ll be sure to reach out next time I am in town. Thanks again!",
    },
    {
      name: "Jacob Dowden",
      date: "November 5, 2024",
      text: "Great company, easy to book and fantastic selection of cars. Highly recommend to anyone coming into Kelowna looking for rentals.",
    },
    {
      name: "David H.",
      date: "September 24, 2024",
      text: "Pickup and drop off extremely efficient, car was in great shape, love not having to have the car at full charge on drop off.",
    },
    {
      name: "David P.",
      date: "August 12, 2024",
      text: "Great rental – the host accommodated multiple booking adjustments due to flight changes. The Bronco was in great shape, instructions were easy, and it was fun to drive.",
    },
    {
      name: "Greg A.",
      date: "December 27, 2024",
      text: "Great host – car was immaculate. Would rent again from them any time. Could not have had a better experience.",
    },
    // NEW REVIEWS
    {
      name: "Anonymous",
      date: "May 15, 2025",
      text: "Well that was fun. What a great way to spend a couple of days. Driving a convertible to Oliver for lunch. Joey is so easy to work with, meeting me at two different locations for pick up and drop off. Definitely worth it to rent this super car and have a little fun. Don’t think twice. Makes a great gift for a spouse. Great experiences you remember, possessions can fade. Thanks Joey. See you again soon! PS. I think it looks good in my driveway.",
    },
    {
      name: "Anonymous",
      date: "May 8, 2025",
      text: "I rented the C8 Corvette from Joey and it’s been great! Excellent communication and the car was super easy and efficient to pick up and drop off. Will most likely rent from these guys again. Highly recommend!",
    },
    {
      name: "Kyler Assam",
      date: "May 31, 2025",
      text: "Amazing Experience! Had a great time renting the raptor and I will be telling family and friends in the area when they visit!",
    },
  ];

  return (
    <Layout>
      <section className="p-6 sm:p-8 lg:p-16 text-center">
        <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold mb-6">What Our Customers Say</h2>
        <p className="text-lg sm:text-xl lg:text-2xl mb-4">
          Real experiences from real customers. See what makes us a top choice for car rentals!
        </p>
      </section>

      {/* Reviews Section with Grid Layout */}
      <section className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-4 gap-6 px-6 sm:px-8 lg:px-16 mb-6">
        {reviews.map((review, index) => (
          <div key={index} className="bg-white shadow-md rounded-2xl p-6">
            <div className="flex justify-between items-center mb-2">
              <h3 className="text-black text-xl font-semibold">{review.name}</h3>
              <p className="text-gray-500 text-sm">{review.date}</p>
            </div>
            <div className="flex items-center mb-4">
              <img src="/reviews/stars.png" alt="Stars" className="h-5 w-auto" />
            </div>
            <p className="text-gray-600">{review.text}</p>
          </div>
        ))}
      </section>
    </Layout>
  );
}

export default Testimonials;
